import { LoginReport } from '~/features/LoginReport';

export const Screen: React.FC = () => <LoginReport />;
